import React, { useState } from 'react'
import { Link } from "react-router-dom";
import { GiHamburgerMenu } from 'react-icons/gi';
import { IoMdClose } from 'react-icons/io';
import emailjs from "@emailjs/browser";
const PopUp = () => {
  const [toggle, setToggle] = useState(false);
    const CloseClick = () => {
      setToggle(false);
  
    };
    const [ismobile, setIsmobile] = useState(0);
  
    // const { categorytotal } = useSelector((store) => store.categoryAll);
  
  
    const [showAbout, setShowAbout] = useState(true);
    const [showInterior, setShowInterior] = useState(true);
    const [showGallery, setShowGallery] = useState(true);
  
    const closemenu = () => {
      document.getElementById("mytogglebtn").classList.add("collapsed");
      document.getElementById("menu").classList.remove("in");
    };
  
  
  
    const [name, setName] = useState("");
    const [mail, setmail] = useState("");
    const [massages, setMassages] = useState("");
    const [number, setNumber] = useState("");
    const [state, setState] = useState("");
    const [subject, setSubject] = useState("");
    const [city, setCity] = useState("");
  
    const nameChange = (e) => {
      const value = e.target.value;
      setName(value);
    };
    const stateChange = (e) => {
      const value = e.target.value;
      setState(value);
    };
    const cityChange = (e) => {
      const value = e.target.value;
      setCity(value);
    };
    const subjectChange = (e) => {
      const value = e.target.value;
      setSubject(value);
    };
    const numberChange = (e) => {
      const value = e.target.value;
      setNumber(value);
    };
  
    const mailChange = (e) => {
      const value = e.target.value;
      setmail(value);
    };
    const massagesChange = (e) => {
      const value = e.target.value;
      setMassages(value);
    };
  
  
    const sendEmail = (e) => {
      e.preventDefault();
      emailjs
        .sendForm(
  
        // "service_oumku8k",
        // "template_esy4tqm",
        // "#myForm",
        // "8i7i_APkS7sZ9CqPl"
      )
        .then(
          function (response) {
            console.log("SUCCESS!", response.status, response.text);
            if (response.text === "OK") {
              setName("");
              setmail("");
              setMassages("");
              setNumber("");
              setState("");
              setSubject("");
              setCity("");
  
            }
          },
          function (error) {
            console.log("FAILED...", error);
          }
        );
    };
  return (
    <>

      {/* PopUp */}

      <div className="container" style={{ marginBottom: "" }}>
        <div className="row">
          <div className="col-md-12">
            <div className="modal" id="mypopUpForm">
              <div className="modal-dialog">
                <div className="modal-content">
                  {/* <div className="modal-header">
                    <h5 style={{ color: '#000' }}>
                      <i className="fa fa-school" style={{ color: "#021257" }}> </i>  <span style={{ color: '#021257' }}> Admissions are now open. Secure your seat today!</span>
                      </h5>
                    <button  onClick={closemenu} style={{ color: "#021257" }} className="close" data-dismiss="modal"><b  onClick={closemenu} style={{ color: "#021257" }}>X</b></button>
                  </div> */}
                  <div className="modal-body">

                    <section id="features" className="features">
                      <div className="" data-aos="fade-up">
                        <div className="row">
                          <div className="col-lg-12" data-aos="fade-left" data-aos-delay={100}>
                            <img src="assets/img/Admissions.webp" alt />
                          </div>
                        </div>
                      </div>
                    </section>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>


    </>
  )
}

export default PopUp